module.exports = __webpack_public_path__ + "img/B2P_PrimaryLockup_Green-Navy.71ca58ba.png";